import axios from 'axios';
import { BlueprintFlowData, FlowScenario } from '../types/flowScenario';
import { access_token, isTokenExpired, refreshAuthToken } from './getAccessToken';
import { getURLFromFunctionName } from './shared';

export async function getFlowDetails(flowScenario: FlowScenario): Promise<BlueprintFlowData> {
  if (!access_token || isTokenExpired(access_token)) {
    await refreshAuthToken();
  }

  const response = await axios.post(
    getURLFromFunctionName('fetchFlowDetails'),
    {
      data: {
        flowScenario,
        getGuideInfo: true,
        getBookingInfo: true,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  if (!response.data || !response.data.data || response.data.data.length === 0) {
    throw new Error('No data found');
  }

  return response.data.data[0];
}
